<template>
  <sModal
    body-style="padding: 0;"
    :closable="false"
    content-style="display: grid; grid-template-rows: 50px 1fr 50px;"
    footer-hide
    fullscreen
    :mask-closable="false"
    :show-head="false"
    :value="open">
    <TooltipedBtn
      v-if="small"
      slot="activator"
      color="var(--black-color)"
      data-qa="youcontrol-btn-open-modal"
      hint-max-width="280px"
      hint-qa="youcontrol-btn-open-modal"
      icon="yc"
      :small-btn="true"
      :text="$t('Tenders.InviteYcHint')"
      @click="open = true">
      <template
        v-if="limitHintShown"
        #text>
        <div>{{ $t('Tenders.InviteYcHint') }}</div>
        <div>{{ $_unknownEmailsLimitHint }}</div>
      </template>
    </TooltipedBtn>
    <sTooltip
      v-else-if="limitHintShown"
      slot="activator"
      :border="false"
      :content="$_unknownEmailsLimitHint"
      :enterable="false"
      placement="bottom"
      type="white">
      <sButton
        class="ml-auto"
        data-qa="youcontrol-btn-open-modal"
        icon="yc"
        icon-size="12px"
        type="border"
        @click="open = true">
        {{ $t('Tenders.AddedFromYK') }}
      </sButton>
    </sTooltip>
    <sButton
      v-else
      slot="activator"
      class="ml-auto"
      data-qa="youcontrol-btn-open-modal"
      icon="yc"
      icon-size="12px"
      type="border"
      @click="open = true">
      {{ $t('Tenders.AddedFromYK') }}
    </sButton>
    <div
      class="youcontrol__content">
      <Breadcrumbs
        v-if="!small"
        class="youcontrol__breadcrumbs"
        :items="breadcrumbs"/>
      <sButton
        v-if="useTestBtn"
        data-qa="test-values"
        style="position: fixed; top: 0; right: 0;"
        @click="test">
        test
      </sButton>
      <iframe
        v-if="open"
        ref="myIframe"
        class="youcontrol__iframe"
        :class="{'is-big': small}"
        :name="`smarttender_${env}`"
        sandbox="allow-same-origin allow-storage-access-by-user-activation allow-scripts allow-modals allow-popups allow-downloads allow-popups-to-escape-sandbox"
        :src="iframeHref"
        title="youcontrol"
        width="400"/>
      <div class="youcontrol__footer">
        <sButton
          data-qa="btn-file-exit"
          icon="long-arrow"
          icon-class="s-svg-icon-rotate-90"
          small
          type="text"
          @click="open = false">
          {{ $t('Common.Back') }}
        </sButton>
        <div
          v-if="isNotProduction">
          {{ tempProps }}
        </div>
      </div>
    </div>
  </sModal>
</template>
<script>
import { eventBus } from '@/main'
import { storageMixin } from 'mixins'
import tour from 'mixins/tour'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import youcontrol from 'mixins/youcontrol.js'
import unknownEmailsLimitMixin from '@/mixins/unknownEmailsLimitMixin.js'

export default {
  name: 'Youcontrol',
  mixins: [ tour, storageMixin, youcontrol, unknownEmailsLimitMixin ],
  data() {
    return {
      open: false,
      tempProps: '',
      breadcrumbs: [
        {
          text: this.$t('Tenders.Members'),
          action: () => this.open = false
        },
        {
          text: 'YC.Market',
        },
      ]
    }
  },
  methods: {
    test() {
      this.checkResultYoucontrol([
        {'email': 'mail1@mail1.trading','name': 'ТОВ "Д.ТРЕЙДІНГ"','code': '42751799'},
        {'email': 'mail2@mail3.gov.ua','name': 'АТ "НАЦІОНАЛЬНА АТОМНА ЕНЕРГОГЕНЕРУЮЧА КОМПАНІЯ "ЕНЕРГОАТОМ"','code': '24584661'}
      ])
    },
    checkResultYoucontrol(props) {
      if (!props?.length) {
        return
      }
      const result = this.$_getUniqueEmails(props)

      if (result?.emails?.length) {
        this.$emit('result', result?.emails)
      }
      this.open = false
    },
  },
  computed: {
    /**
     * При локальной разработке не работает Youcontrol
     */
    useTestBtn() {
      return window?.config?.node_env === 'development'
    },
    /**
     * Рядок про ліміт у тултіпі кнопки; на етапі 7 (hideLimitHint) незареєстрованих запросити не можна
     */
    limitHintShown() {
      return this.$_unknownEmailsLimitActive && !this.hideLimitHint
    }
  },
  mounted() {
    const key = `youcontrol_tour${this.small ? 'small' : ''}`
    this.$_getPropFromDBStorage(key, false)
      .then(async (viewedTour) => {
        if (viewedTour) { return }
        let tour = []
        if (this.small) {
          tour = [
            {
              dataKey: 'youcontrol-btn-open-modal',
              title: this.$t('Tenders.youcontrol.tour.step1Title'),
              text: this.$t('Tenders.youcontrol.tour.step1Description'),
              step: 1,
              tooltipClass: 'youcontrol-tour-step'
            },
            {
              dataKey: 'youcontrol-btn-open-modal',
              title: this.$t('Tenders.youcontrol.tour.step2Title'),
              text: this.$t('Tenders.youcontrol.tour.step2Description'),
              step: 2,
              tooltipClass: 'youcontrol-tour-step'
            },
          ]
        } else {
          tour = [
            {
              dataKey: 'youcontrol-btn-open-modal',
              title: this.$t('Common.NewFunctionality'),
              text: this.$t('Common.YouControlTour'),
              step: 1,
              tooltipClass: 'youcontrol-tour-step'
            },
          ]
        }
        eventBus.$emit('startTour', tour)
        await this.$_savePropToDBStorage(key, true)
      })

  },
  components: {
    Breadcrumbs,
    TooltipedBtn
  },
  props: {
    small: {
      type: Boolean
    },
    hideLimitHint: {
      type: Boolean
    }
  }
}
</script>
<style>
.youcontrol-tour-step {
  min-width: 400px;
}
</style>
<style scoped lang="scss">
.youcontrol {
  &__content {
    height: 100%;
    width: 100%;
  }
  &__breadcrumbs {
    padding: 20px 0  4px 32px !important;
  }
  &__iframe {
    height: calc(100% - 117px);
    width: 100%;
    border: none;
    display: block;
    &.is-big {
      height: calc(100% - 60px);
    }
  }
  &__footer {
    height: 60px;
    padding: 14px 15px;
    background-color: var(--v-main__green-base) !important;
    border-color: var(--v-main__green-base) !important;
  }
}
</style>
